var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"container"}},[_c('a',{staticClass:"cart-modal-action",attrs:{"tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.openCartModal.apply(null, arguments)}}},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }